import { faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TriangleExclamationIcon, CircleInfoIcon, StarsIcon } from '@revfluence/fresh-icons/solid';
import React, { useState } from 'react';

export interface IAlertProps {
  children?: React.ReactNode;
  type?: 'success' | 'error' | 'info' | 'unAuthorized';
}

const alertStyles = {
  success: 'bg-green-100 p-4 text-green-900 text-primary',
  unAuthorized: 'bg-yellow-2 p-4 text-primary',
  error: 'bg-alert-error text-primary',
  info: 'bg-grey-2 border-grey-5 text-primary',
};

const alertIcons = {
  success: <StarsIcon className="w-4 h-4 mr-2 green-900" />,
  unAuthorized: <StarsIcon className="w-4 h-4 mr-2 bg-yellow-2" />,
  error: <TriangleExclamationIcon className="w-4 h-4 mr-2 text-destructive" />,
  info: <CircleInfoIcon className="w-4 h-4 mr-2 text-primary" />,
};

const ContentPreviewAlert: React.FC<IAlertProps> = ({
  children,
  type = 'error',
}) => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className={`flex items-center justify-between rounded-lg p-4 ${alertStyles[type]}`}>
      <div className="flex items-center gap-2">
        <div className="w-4 h-4">
          {alertIcons[type]}

        </div>
        {children}
      </div>
      <button
        onClick={handleClose}
        className="text-green-900 hover:text-green-700"
        aria-label="Dismiss"
      >
        <FontAwesomeIcon icon={faClose} />
      </button>
    </div>
  );
};

export default ContentPreviewAlert;
